import { FormErrorDirective } from './core/directives/form-error.directive';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { AppFooterComponent } from './components/app-footer/app-footer.component';
import { AppHeaderComponent } from './components/app-header/app-header.component';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PagamentoComponent } from './components/pagamento/pagamento.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClient, HttpClientModule } from '@angular/common/http';

import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatExpansionModule } from '@angular/material/expansion';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';

import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha';
import { NgxUpperCaseDirectiveModule } from 'ngx-upper-case-directive';
import { APP_BASE_HREF } from '@angular/common';
import { EsitoComponent } from './components/esito/esito.component';
import { ResourceInitializerService } from './core/services/resource-initializer.service';
import {MatTooltipModule} from "@angular/material/tooltip";
import {NativeElementInjectorDirective} from "./core/directives/native-element-injector.directive";

function initializeAppFactory(resourceInitializerService: ResourceInitializerService): () => void {
  return () => resourceInitializerService.load();
 }

@NgModule({
  declarations: [
    FormErrorDirective,
    NativeElementInjectorDirective,
    AppComponent,
    AppHeaderComponent,
    AppFooterComponent,
    PagamentoComponent,
    EsitoComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatIconModule,
    MatTooltipModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (http: HttpClient) =>
          new TranslateHttpLoader(http, 'assets/i18n/', '.json'),
        deps: [HttpClient],
      },
    }),
    ReactiveFormsModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    MatExpansionModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    NgxUpperCaseDirectiveModule
  ],
  providers: [
    {provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: {appearance: 'standard'}},
    {provide: APP_BASE_HREF, useValue: '/PagamentiArisgan/'},
    ResourceInitializerService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeAppFactory,
      multi: true,
      deps: [ResourceInitializerService],
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
